import { computed } from 'vue';
import { useContext } from '@nuxtjs/composition-api';

export const useStoreInNodes = () => {
  const context = useContext();

  const store = computed(() => context?.$store || context?.store || {});

  return {
    store,
  };
};
